<div class="or-h-100vh or-d-flex or-flex-col">
  <lib-auth-header text="Zaloguj się by korzystać z aplikacji"></lib-auth-header>

  <div
    slot="start"
    class="or-position-absolute or-ml-8-px or-top-0"
    [ngClass]="isiOS ? 'or-mt-52-px' : 'or-mt-12-px'"
    (click)="goBack()">
    <img src="assets/icons/back-arrow-icon.svg" />
  </div>

  <auth-form (actionEvent)="login($event)" [isRegister]="false"></auth-form>
</div>
